require('../core/grpn-lazyload');

module.exports = Groupon.Utils.lazyLoadImages = function(options, triggerClass) {
  var $el;
  if (triggerClass == null) {
    triggerClass = '.lazy-load';
  }
  if (($el = $(triggerClass)).length) {
    $el.lazyload(options);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL2xhenlMb2FkSW1hZ2VzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9sYXp5TG9hZEltYWdlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBQSxDQUFRLHVCQUFSOztBQUVBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLE9BQU8sQ0FBQyxLQUFLLENBQUMsY0FBZCxHQUErQixTQUFDLE9BQUQsRUFBVSxZQUFWO0FBQzlDLE1BQUE7O0lBRHdELGVBQWU7O0VBQ3ZFLElBQXlCLENBQUMsR0FBQSxHQUFNLENBQUEsQ0FBRSxZQUFGLENBQVAsQ0FBdUIsQ0FBQyxNQUFqRDtJQUFBLEdBQUcsQ0FBQyxRQUFKLENBQWEsT0FBYixFQUFBOztBQUQ4QyJ9
